import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectors as settingsSelectors } from 'state/settings';
import { selectors as authSelectors } from 'state/auth';
import api from 'api/api';

import CardForm from 'refactored/features/soForm/steps/card/creditCard/Form/components/CardForm/component';
import {
  useSoFormStepsApi,
  useSoFormStepsState,
} from 'refactored/features/soForm/SoForm.context';
import { captureCatalogError } from 'sentry';
import SoFormStepCard from '../../../../SoFormStepCard';

// export default enhance(CardForm);

const delay = (delayInms) => {
  return new Promise((resolve) => setTimeout(resolve, delayInms));
};

const Alternative = () => {
  const { t } = useTranslation('CreditCard');
  const stepsState = useSoFormStepsState();
  const stepsApi = useSoFormStepsApi();
  const quote = stepsState.activeQuote;

  const billingEmail = useSelector(settingsSelectors.getFinanceEmail);
  const country = useSelector(settingsSelectors.getCountrySettings);
  const taxNumber = useSelector(authSelectors.getUserShipperTaxNumber);
  const fullPrice = Number(quote.gross_full_price) || 0;
  const errors = [];
  const warnings = [];
  const hasQuoteError = false;
  const isSubmitting = false;
  const paymentIntentSecret = stepsState.card.paymentIntentSecret;

  const handleSubmitPay = async ({ paymentIntent }) => {
    const intent_id = paymentIntent.id;
    const soId = stepsState.card.id;

    await delay(3000);

    try {
      await api.confirmPaymentIntent({ soId, intent_id });
      stepsApi.onCardPaymentCompleted();
    } catch (e) {
      captureCatalogError({
        e,
        step_name: SoFormStepCard.nameForData,
        error_type: 'API',
        action_name: 'handleSubmitPay ',
        extras: { soId, intent_id },
      });
    }
  };

  const props = {
    billingEmail,
    country,
    taxNumber,
    fullPrice,
    errors,
    warnings,
    hasQuoteError,
    isSubmitting,
    paymentIntentSecret,
    t,
    handleSubmitPay,
  };
  return <CardForm {...props} />;
};

export default Alternative;
